var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("csp-desktop-firm-configurable-documents", {
            attrs: {
              cols: 12,
              "context-id": 1,
              "context-type": "reseller",
              "form-context": _vm.dummyFormContext,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }